import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ProductPricebookItem } from "../../../types/product.type";
import { formatCataloguePrice } from "../shared/constants";

interface PricebookItemPriceProps {
  item: Pick<ProductPricebookItem, "price" | "price_incl_vat" | "price_ex_vat">;
  /** Where the two lines sit: against the right edge of a list, or in a centred table column. */
  alignment?: "flex-end" | "center";
}

/**
 * A product's selling prices in one pricebook, incl and ex VAT. A line the discount-model
 * migration has not reached has neither and still bills at its legacy price, shown instead.
 */
export default function PricebookItemPrice({
  item,
  alignment = "flex-end",
}: PricebookItemPriceProps) {
  if (item.price_incl_vat === null || item.price_ex_vat === null) {
    return (
      <Stack alignItems={alignment}>
        <Typography variant="body2" fontWeight={500} noWrap>
          ราคาเดิม {formatCataloguePrice(item.price)}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          ยังไม่ย้ายราคา
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack alignItems={alignment}>
      <Typography variant="body2" fontWeight={500} noWrap>
        รวม VAT {formatCataloguePrice(item.price_incl_vat)}
      </Typography>
      <Typography variant="caption" color="text.secondary" noWrap>
        ก่อน VAT {formatCataloguePrice(item.price_ex_vat)}
      </Typography>
    </Stack>
  );
}
